import { useEffect } from "react";
import { SignIn, useAuth } from "@clerk/react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useMe } from "@/context/MeContext";
import { Wordmark } from "@/components/Wordmark";

const NotAdmin = () => (
  <div className="space-y-3 text-center" data-testid="admin-login-denied">
    <p className="font-serif text-2xl">This account isn't an admin</p>
    <p className="text-sm text-slate-500">Ask an existing Middle admin to give your account admin access.</p>
    <Link to="/" className="text-sm underline" data-testid="admin-login-home">Back to Middle</Link>
  </div>
);

const Gate = () => {
  const { me } = useMe();
  const nav = useNavigate();
  useEffect(() => { if (me?.role === "admin") nav("/admin", { replace: true }); }, [me, nav]);
  return me && me.role !== "admin" ? <NotAdmin /> : <p className="text-sm text-slate-500">Checking your access…</p>;
};

export default function AdminLogin() {
  const { isLoaded, isSignedIn } = useAuth();
  return (
    <div className="grid min-h-screen place-items-center bg-[#1B2232] p-6" data-testid="admin-login-page">
      <section className="w-full max-w-md space-y-5 rounded-2xl bg-[#FAF8F5] p-6 shadow-xl">
        <div className="flex items-center justify-between"><Wordmark /><span className="inline-flex items-center gap-1 rounded-full bg-slate-900 px-3 py-1 text-xs font-medium text-white"><ShieldCheck size={13} />Admin</span></div>
        <div><h1 className="font-serif text-3xl">Admin sign in</h1><p className="mt-1 text-sm text-slate-500">Use your Middle account. Only accounts with admin access can continue.</p></div>
        {!isLoaded ? null : isSignedIn ? <Gate /> : (
          <SignIn routing="path" path="/admin/login" forceRedirectUrl="/admin/login" signUpUrl="/sign-up" appearance={{ elements: { rootBox: "w-full", card: "w-full shadow-none bg-transparent" } }} />
        )}
      </section>
    </div>
  );
}
